export default {
  showOnlyAvailableApps: 'Nur verfügbare Apps anzeigen',
};
